import React, { useState, useEffect } from 'react'
import cyprusFamTour2025Img from '../images/cyprusFamTour2025_2.jpg'
import { applyForCyprusFamTourAppFxn, cyprusFamTourAppFxn } from '../action'
import { Col, Row, Card, Checkbox, notification, Modal, Table } from 'antd'
import { useDispatch } from 'react-redux'
import { displayDate } from '../../../components/_utils/appUtils'

const requiredAppCount = {
  10: 'One economy class return flight for a company representative.',
  20: 'Two representatives from the company (economy class return flights)',
  30: 'Choose of one business class return flight or three economy class return flights for company representatives.'
}

const AppListComponent = (props) => {
  let { visible, records, onClose } = props

  const columns = [{
    title: '#',
    dataIndex: '_id',
    key: '_id',
    width: 120,
    render: (text, record, index) => {
      return (
        <strong>{index + 1}</strong>
      )
    }
  },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
      render: (text, record) => {
        return (
          <>
            {record && record.countryCode ? record.countryCode : ''} {text}
          </>
        )
      }
    },
    {
      title: 'Program Name',
      dataIndex: 'applications.courseName',
      key: 'applications.courseName'
    },
    {
      title: 'University',
      dataIndex: 'applications.courseUniversity',
      key: 'applications.courseUniversity',
      render: (text, record) => {
        return (
          <>
            {text && text.universityName ? text.universityName : ''}
          </>
        )
      }
    },
    {
      title: 'Intake',
      dataIndex: 'applications.intake',
      key: 'applications.intake',
      render: (item) => {
        return (
          <>
            {item && item.month ? item.month : ''}, {item && item.year ? item.year : ''}
          </>
        )
      }
    }
  ]

  return (
    <Modal visible={visible} onCancel={onClose} width={'65%'} title={'Applications List'} footer={false}>
      <Table columns={columns}
             dataSource={records}
             bordered={true}
             pagination={false}
             size={'small'}
      />
    </Modal>
  )
}

const AchieveComponent = (props) => {
  let { achieved, requiredCount, totalApp } = props
  return (
    <>
      {achieved ? <div>
        Congratulations you have achieved {requiredAppCount[achieved]}
      </div> : null}
      {requiredCount ? <div className={'mt20'}>
        You have need <b className={'red'}>{(requiredCount - totalApp)} student(s)</b> more to
        achieve {requiredAppCount[requiredCount]}
      </div> : null}
    </>
  )
}

const FamTour2025 = () => {
  let dispatch = useDispatch()
  let [totalApp, setTotalApp] = useState(0)
  let [records, setRecords] = useState([])
  let [termAccepted, setTermAccepted] = useState(false)
  let [visibleApp, setVisibleApp] = useState(false)
  let [appliedData, setAppliedData] = useState({})
  const events = {
    getFamTour: async () => {
      let resp = await cyprusFamTourAppFxn()
      if (resp) {
        if (resp.totalApp) {
          setTotalApp(resp.totalApp)
        }
        if (resp.records) {
          setRecords(resp.records)
        }
        if (resp.appliedData) {
          setAppliedData(resp.appliedData)
        }
      }
    },
    onCheck: e => {
      setTermAccepted(!termAccepted)
    },
    onSubmit: async () => {
      if (!termAccepted) {
        return notification.warn({ message: 'Please accept terms & conditions.' })
      }
      /*if (totalApp < 10) {
        return notification.warn({ message: 'Sorry minimum 10 students are required to apply in fam tour 2025.' })
      }*/
      let appliedFor = 10
      if (totalApp >= 30) {
        appliedFor = 30
      } else if (totalApp >= 20) {
        appliedFor = 20
      } else if (totalApp >= 10) {
        appliedFor = 10
      }
      let resp = await dispatch(applyForCyprusFamTourAppFxn({
        totalApplications: totalApp,
        appliedFor,
        details: requiredAppCount[appliedFor]
      }))
      if (resp && resp.success) {
        setTermAccepted(false)
        setVisibleApp(false)
      }
      events.getFamTour()

    }
  }
  useEffect(() => {
    events.getFamTour()
  }, [])
  return (
    <>
      <div className={'fam-tour-block'}>

        <Row gutter={20}>
          <Col span={12}>
            <div className={'img-box'}>
              <img src={cyprusFamTour2025Img} />
            </div>
          </Col>
          <Col span={12}>
            <div className={'fam-tour-content'}>
              <div className={'inner-content-box'}>

                <div className={'align-center'} key={totalApp}>
                  <div>
                    <div className={'title'}>
                      Total Applications : {totalApp}
                    </div>
                    <a className={'btn btn-link f-12 sm hyperLinkUnderLine'} onClick={() => setVisibleApp(true)}>
                      Click to View Applications
                    </a>
                  </div>

                  <div className={'mt40'}>
                    {totalApp >= 30 ?
                      <div>
                        <AchieveComponent achieved={30} requiredCount={0} totalApp={totalApp} />
                      </div>
                      : totalApp >= 20 ?
                        <div>
                          <AchieveComponent achieved={20} requiredCount={30} totalApp={totalApp} />
                        </div>
                        : totalApp >= 10 ?
                          <div>
                            <AchieveComponent achieved={10} requiredCount={20} totalApp={totalApp} />
                          </div>
                          : <div>
                            <AchieveComponent achieved={0} requiredCount={10} totalApp={totalApp} />
                          </div>
                    }
                  </div>
                </div>

                {appliedData && appliedData._id ?
                  <>

                    <div className={`fam-tour-info`}>
                      <div>
                        Already Applied On :- <b>{displayDate(appliedData.createdAt)}</b>
                      </div>
                    </div>
                  </>
                  : <div className={'align-left mt40'}>
                    <label>
                      <Checkbox checked={termAccepted} onChange={events.onCheck} />&nbsp; I Accept all the terms &
                      conditions
                    </label>
                    <a className={'btn btn-block btn-success roundNew lg mt10'} onClick={events.onSubmit}>
                      CLICK HERE TO SUBMIT
                    </a>
                  </div>}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {visibleApp ?
        <AppListComponent
          records={records}
          onClose={() => setVisibleApp(false)}
          visible={visibleApp} /> : null}
    </>
  )
}
export default FamTour2025
